import { cn } from "@/lib/utils";

const STYLES = {
    active:     "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]",
    inactive:   "bg-muted text-muted-foreground",
    on_leave:   "bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]",
    terminated: "bg-[hsl(var(--destructive))]/10 text-[hsl(var(--destructive))]",
};

const LABELS = {
    active: "Aktif",
    inactive: "Pasif",
    on_leave: "İzinli",
    terminated: "Ayrılmış",
};

export default function StatusBadge({ status, className }) {
    const s = status || "active";
    return (
        <span className={cn(
            "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-semibold",
            STYLES[s] || STYLES.active,
            className
        )}>
            <span className={cn(
                "h-1.5 w-1.5 rounded-full",
                s === "active" && "bg-[hsl(var(--success))]",
                s === "inactive" && "bg-muted-foreground/60",
                s === "on_leave" && "bg-[hsl(var(--warning))]",
                s === "terminated" && "bg-[hsl(var(--destructive))]",
            )} />
            {LABELS[s] || s}
        </span>
    );
}
